import { version } from '../package.json';

import Vue from "vue";

import App from "./App.vue";
import router from "./router";
import store from "./store";

import vuetify from "./plugins/vuetify";
import moment from "./plugins/moment";
import currency from "./plugins/currency";
import arabic from "./plugins/arabic";
import Helper from "./plugins/Helper";
import eventBus from "./plugins/eventBus";
import i18n from "./plugins/vue-i18n";
// import "./plugins/SSO";

import snackbarPlugin from "./plugins/snackbar";
import Vuetify from "vuetify";
import Ripple from "vuetify/lib/directives/ripple";
import VueThailandAddress from "vue-thailand-address";
import VueFormulate from "@braid/vue-formulate";
import konva from "vue-konva";
import { VueMasonryPlugin } from "vue-masonry";
import * as Sentry from "@sentry/vue";
import VueCurrencyInput from 'vue-currency-input'
import VCurrencyField from "./components/VCurrencyField.vue";

import "./assets/styles/tailwind.css";
import 'chart.js/auto';
import 'leaflet/dist/leaflet.css';

Vue.use(snackbarPlugin, { store });
Vue.use(VueFormulate);
Vue.use(VueThailandAddress);
Vue.use(moment);
Vue.use(currency);
Vue.use(arabic);
Vue.use(Helper);
Vue.use(eventBus);
Vue.use(Vuetify, {
  directives: {
    Ripple
  }
});
Vue.use(konva, { prefix: "konva" });
Vue.use(VueMasonryPlugin);
Vue.use(VueCurrencyInput, {
  globalOptions: {
    currency: null,
    distractionFree: false,
    precision: {
      min: 0,
      max: 2
    },
  }
})
Vue.component("v-currency-field", VCurrencyField);
Vue.mixin({
  methods: {
    $e: param => eval("this." + param)
  }
});

// css 1
import "./assets/styles/main.scss";
import "./assets/styles/tailwind.css";
import "./assets/styles/paper.css";

Vue.config.productionTip = false;
Vue.prototype.$globalLocale = "th";
Vue.prototype.$globalCurrencyCode = "THB"
Vue.prototype.$globalVatPercent = parseFloat(process.env.VUE_APP_VAT_PERCENT) || 7
Vue.prototype.$globalCurrencySupports = ["THB"]

Sentry.init({
  Vue,
  dsn: process.env.VUE_APP_SENTRY_DSN,
  release: `market-frontend@${version}`, // Set release version from package.json
  environment: process.env.VUE_APP_ENV || "development"
});

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount("#app");
